import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"

import { getPrimaryColor } from "theme/palette"

const renderNextButton = (theme) => (
  <svg viewBox='0 0 24 28' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
    <g id='Next' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <path
        d='M6.78495886,6.66244121 C7.45319582,5.78278214 8.5317237,5.77559769 9.20612113,6.66244121 L19.6583084,20.4072364 C20.3272425,21.2868954 19.9836359,22 18.87149,22 L-2.86825609,22 C-3.97173795,22 -4.33003135,21.2940799 -3.65633668,20.4072364 L6.78495886,6.66244121 Z'
        id='Path'
        fill={getPrimaryColor(theme)}
        transform='translate(8.000000, 14.000000) rotate(90.000000) translate(-8.000000, -14.000000) '
      />
      <rect id='Rectangle-4-Copy' fill={getPrimaryColor(theme)} x='18' y='1' width='6' height='26' rx='3' />
    </g>
  </svg>
)

const renderDisabledNextButton = (theme) => (
  <svg viewBox='0 0 24 28' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
    <g id='Next' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <path
        d='M6.78495886,6.66244121 C7.45319582,5.78278214 8.5317237,5.77559769 9.20612113,6.66244121 L19.6583084,20.4072364 C20.3272425,21.2868954 19.9836359,22 18.87149,22 L-2.86825609,22 C-3.97173795,22 -4.33003135,21.2940799 -3.65633668,20.4072364 L6.78495886,6.66244121 Z'
        id='Path'
        fill='#BEBEBE'
        transform='translate(8.000000, 14.000000) rotate(90.000000) translate(-8.000000, -14.000000) '
      />
      <rect id='Rectangle-4-Copy' fill='#BEBEBE' x='18' y='1' width='6' height='26' rx='3' />
    </g>
  </svg>
)

const renderPrevButton = (theme) => (
  <svg viewBox='0 0 24 28' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
    <g id='Previous-Dark' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <path
        d='M14.7849589,6.66244121 C15.4531958,5.78278214 16.5317237,5.77559769 17.2061211,6.66244121 L27.6583084,20.4072364 C28.3272425,21.2868954 27.9836359,22 26.87149,22 L5.13174391,22 C4.02826205,22 3.66996865,21.2940799 4.34366332,20.4072364 L14.7849589,6.66244121 Z'
        id='Path-Copy'
        fill={getPrimaryColor(theme)}
        transform='translate(16.000000, 14.000000) scale(-1, 1) rotate(90.000000) translate(-16.000000, -14.000000) '
      />
      <rect id='Rectangle-4' fill={getPrimaryColor(theme)} x='0' y='1' width='6' height='26' rx='3' />
    </g>
  </svg>
)

const renderPlayButton = (theme) => (
  <svg viewBox='0 0 40 44' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
    <defs>
      <path
        d='M37.9375,18.5046745 L5.9375,0.507974199 C4.75,-0.179399772 3.1875,-0.179399772 2,0.570462742 C0.75,1.25783671 0,2.57009611 0,4.0073326 L0,40.0007333 C0,41.4379697 0.75,42.7502291 2,43.4376031 C2.625,43.8125344 3.3125,44 4,44 C4.6875,44 5.375,43.8125344 5.9375,43.5000917 L37.9375,25.5033913 C39.25,24.7535288 40,23.4412694 40,22.0040329 C40,20.5667964 39.25,19.254537 37.9375,18.5046745 Z'
        id='path-1'
      />
    </defs>
    <g id='Play-Button' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <mask id='mask-2' fill={getPrimaryColor(theme)}>
        <use xlinkHref='#path-1' />
      </mask>
      <use id='play' fill={getPrimaryColor(theme)} xlinkHref='#path-1' />
    </g>
  </svg>
)

const renderPauseButton = (theme) => (
  <svg viewBox='0 0 40 44' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
    <g id='Pause-Button-Dark' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='Pause-Button' transform='translate(6.000000, 0.000000)' fill={getPrimaryColor(theme)}>
        <rect id='Rectangle-4' x='0' y='0' width='10' height='44' rx='5' />
        <rect id='Rectangle-4-Copy' x='18' y='0' width='10' height='44' rx='5' />
      </g>
    </g>
  </svg>
)

const renderShareButton = (theme) => (
  <svg viewBox='0 0 27 38' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
    <g id='Share-Icon-3px' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g transform='translate(2.000000, 2.000000)'>
        <path
          d='M6,12 L3,12 C1.34314575,12 -1.53517375e-15,13.3431458 -1.33226763e-15,15 L-1.77635684e-15,31 C-1.57345071e-15,32.6568542 1.34314575,34 3,34 L20,34 C21.6568542,34 23,32.6568542 23,31 L23,15 C23,13.3431458 21.6568542,12 20,12 L17,12'
          id='Share-Box'
          stroke={getPrimaryColor(theme)}
          strokeWidth='3'
          strokeLinecap='round'
        />
        <path
          d='M5,6 L10,1 C11,6.16173779e-15 12,1.03250741e-14 13,1 C13.039008,1.03900801 14.7056747,2.70567467 18,6'
          id='Top-Arrow-Head'
          stroke={getPrimaryColor(theme)}
          strokeWidth='3'
          strokeLinecap='round'
          transform='translate(11.500000, 3.125000) rotate(-360.000000) translate(-11.500000, -3.125000) '
        />
        <path
          d='M10,0 L13,0 L13,19.5 C13,20.3284271 12.3284271,21 11.5,21 L11.5,21 C10.6715729,21 10,20.3284271 10,19.5 L10,0 Z'
          id='Middle-Bar'
          fill={getPrimaryColor(theme)}
        />
      </g>
    </g>
  </svg>
)

const ControlButtonCSS = css`
  background-size: contain;
  cursor: pointer;
  user-select: none;
  flex-grow: 0;
  flex-shrink: 0;
`

const ControlButtonShare = styled.div`
  ${ControlButtonCSS};
  margin-left: 30px;
  height: 34px;
  flex-basis: 23px;
`

const ControlButtonPlayPause = styled.div`
  ${ControlButtonCSS};
  margin: 0 26px;
  height: 44px;
  flex-basis: 40px;
`

const ControlButtonPrevNext = styled.div`
  ${ControlButtonCSS};
  height: 30px;
  flex-basis: 26px;
  ${({ disabled }) => (disabled ? `
    cursor: auto;
    pointer-events: none;
    fill: blue;
  ` : "")}; 
`

const ControlButton = ({
  type,
  theme,
  disabled,
  ...rest
}) => {
  if (type === "play") {
    return <ControlButtonPlayPause {...rest}>{renderPlayButton(theme)}</ControlButtonPlayPause>
  }
  if (type === "pause") {
    return <ControlButtonPlayPause {...rest}>{renderPauseButton(theme)}</ControlButtonPlayPause>
  }
  if (type === "prev") {
    return <ControlButtonPrevNext {...rest}>{renderPrevButton(theme)}</ControlButtonPrevNext>
  }
  if (type === "next") {
    if (disabled) {
      return <ControlButtonPrevNext disabled {...rest}>{renderDisabledNextButton(theme)}</ControlButtonPrevNext>
    }
    return <ControlButtonPrevNext {...rest}>{renderNextButton(theme)}</ControlButtonPrevNext>
  }
  if (type === "share") {
    return <ControlButtonShare {...rest}>{renderShareButton(theme)}</ControlButtonShare>
  }
  return <ControlButtonPlayPause {...rest}>{renderPlayButton(theme)}</ControlButtonPlayPause>
}

ControlButton.propTypes = {
  type: PropTypes.oneOf(["play", "pause", "share", "next", "prev"]),
  theme: PropTypes.oneOf(["light", "dark"]),
  disabled: PropTypes.bool,
}

export default ControlButton



// WEBPACK FOOTER //
// ./src/components/atoms/ControlButton/index.js